import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { SessionService } from '../services/session.service';
import { ARCHIEVE_CODES, COOKIES_CONSTANTS, LANGUAGE_CODES } from '@app/config';

@Injectable()
export class CommonHeaderService {
    langCode: any;
    archMode:any
    constructor(public sessionService: SessionService) { }

    /**
     * return default header of type HttpHeaders
     *
     * @returns {HttpHeaders} headers
     * @memberof CommonHaderService
     */
    getDefaultHeaderRequestParams() {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set('Accept', 'application/json');
        headers = headers.set('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
        let token = '';
        if (this.sessionService.getCookie(COOKIES_CONSTANTS.authToken)) {
            token = this.sessionService.getCookie(COOKIES_CONSTANTS.authToken);
        } else if (!token && this.sessionService.getSessionItem(COOKIES_CONSTANTS.authToken)) {
            token = this.sessionService.getSessionItem(COOKIES_CONSTANTS.authToken);
        }
        if (token) {
            headers = headers.set('Authorization', token);
        } else {
            headers = headers.delete('Authorization');
        }

         this.archMode=this.sessionService.getCookie(COOKIES_CONSTANTS.archiveMode);
        if(!this.archMode){
            this.sessionService.setCookie(COOKIES_CONSTANTS.archiveMode,ARCHIEVE_CODES.DISABLED);
            this.archMode=ARCHIEVE_CODES.DISABLED
        }
        headers=headers.set('archiveMode',this.sessionService.getCookie(COOKIES_CONSTANTS.archiveMode));

        this.langCode = this.sessionService.getCookie(COOKIES_CONSTANTS.langCode);
        if (!this.langCode) {
            this.sessionService.setCookie(COOKIES_CONSTANTS.langCode, LANGUAGE_CODES.en_US);
            this.langCode = LANGUAGE_CODES.en_US;
        }
        if(this.langCode !='en-US' ){
            if (this.langCode != 'es-MX'){
                this.sessionService.setCookie(COOKIES_CONSTANTS.langCode, LANGUAGE_CODES.en_US)
                this.langCode = LANGUAGE_CODES.en_US
            }
        }
        headers = headers.set('Accept-Language', this.langCode);
        headers = headers.set('x-currency', this.sessionService.getCookie(COOKIES_CONSTANTS.currency));
        return headers;
    }

    getVerifyTokenRequestHeaders() {
        let headers = new HttpHeaders();
        headers = headers.set('Authorization', this.sessionService.getCookie(COOKIES_CONSTANTS.authToken));
        return headers;
    }

    /**
     * return header with Authorization
     *
     * @returns {HttpHeaders} headers
     * @memberof CommonHaderService
     */
    public getAuthHeaderRequestParam() {
        let headers = new HttpHeaders();
        headers = headers.delete('Authorization');
        if (this.sessionService.getCookie(COOKIES_CONSTANTS.authToken)) {
            headers = headers.set('Authorization', this.sessionService.getCookie(COOKIES_CONSTANTS.authToken));
        } else if (this.sessionService.getSessionItem(COOKIES_CONSTANTS.authToken)) {
            headers = headers.set('Authorization', this.sessionService.getSessionItem(COOKIES_CONSTANTS.authToken));
        }
        return headers;
    }

    /**
     * set Accept-language on headers
     *
     * @param {HttpHeaders} headers
     * @returns {HttpHeaders} headers
     * @memberof CommonHaderService
     */
    public setLanguageParams(headers: HttpHeaders) {
        if (this.langCode != this.sessionService.getCookie(COOKIES_CONSTANTS.langCode)) {
            headers.delete('Accept-language');
            if(this.langCode !='en-US' || this.langCode !='es-MX' ){
                this.sessionService.setCookie(COOKIES_CONSTANTS.langCode, LANGUAGE_CODES.en_US)
                this.langCode= LANGUAGE_CODES.en_US
            }
            headers = headers.set('Accept-language', this.langCode);
        }
        return headers;
    }

    /**
     * return default headers for multipart
     *
     * @returns {HttpHeaders} headers
     * @memberof CommonHaderService
     */
    public getMultipartHeaders() {
        let headers = this.getAuthHeaderRequestParam();
        headers = this.setLanguageParams(headers);
        headers = headers.set('Accept', 'application/json');
        headers = headers.set('Accept-language', this.sessionService.getCookie(COOKIES_CONSTANTS.langCode));
        return headers;
    }
}



// WEBPACK FOOTER //
// ./src/app/common/http-client/common-header.service.ts